// extracted by mini-css-extract-plugin
export var attribution = "_cq-4";
export var authorName = "_cq-5";
export var quote = "_cq-3";
export var testimonial = "_cq-2";
export var trustedBy = "_cq-0";
export var trustedByLabel = "_cq-1";